<template>
 <div data-app>
  <KTCard v-bind:title="title">
      <template v-slot:body>
        
      <table class="table table-hover table-bordered" id="example">
        <thead>
          <tr>
            <th>İsim Soyisim</th>
            <th>Toplam Borç</th>
            
          </tr>
        </thead>
        <tbody>
          <tr v-for="stat in stats" :key="stat.id">
            <td>{{ stat.user?.name }}</td>
            <td>{{ stat.total_amount }}</td>
            
          </tr>
          
        </tbody>
        <tfoot>
          <tr>
            <td>Toplam:</td>
            <td>{{ sum }}</td>
          </tr>
        </tfoot>
        
      </table>
    
    </template>
  </KTCard>    
</div>  
</template>
   
  <script>
  //import 'bootstrap/dist/css/bootstrap.min.css'; //for table good looks
  import KTCard from "@/view/content/Card.vue";
  import 'jquery/dist/jquery.min.js';
  //Datatable Modules
  import "datatables.net-dt/js/dataTables.dataTables"
  import "datatables.net-dt/css/jquery.dataTables.min.css"
  import "datatables.net-buttons/js/dataTables.buttons.js"
  import "datatables.net-buttons/js/buttons.colVis.js"
  import "datatables.net-buttons/js/buttons.flash.js"
  import "datatables.net-buttons/js/buttons.html5.js"
  import "datatables.net-buttons/js/buttons.print.js"

  import JSZip from 'jszip';
  window.JSZip = JSZip;
  
  import $ from 'jquery'; 
  import { GET_CREDIT_TRANSACTIONS_REPORT } from "@/core/services/store/transactions.module";

  export default {
    data: function() {
          return {
              users:[],
              title: "Borçlu Üye Listesi",
              stats: [],
              sum: 0,
              transactions: [],
              name: "",
              organizational_units: [],
              organizational_unit_id: "",
              registration_number: ""
          }
      },
    
    
    methods: {
      showResults() {
        $('#example').DataTable().destroy();
          this.$store.dispatch(GET_CREDIT_TRANSACTIONS_REPORT)
          .then((response) => {
              
              this.stats = response.data.records;
              this.sum = response.data.sum;
              setTimeout(function(){
                
              $('#example').DataTable(
                  {
                      pagingType: 'full_numbers',
                      pageLength: 25,
                      processing: true,
                      dom: 'Bfrtip',
                      filter: true,
                      retrieve: true,
                      searching: false,
                      paging: true,
                      responsive: true,
                      language: { "url": "assets/Turkish.json" },
                      order: [[0, 'asc']],
                      buttons: [
                      {
                          extend: 'copy',
                          text: 'Kopyala',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'excel', // Excel export button
                          text: 'Excel',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'print',
                          text: 'Yazdır',
                          footer: true,
                          className: 'btn btn-success'
                      },
                    ],
                  }
              );
            },
            1000
            );  
          })
      },

     
    },
    
   
    components: {
       KTCard,
    },

    created() {
      this.showResults();
    },


  }
  </script>
  